import React, { Component } from 'react'
import Modal from 'react-modal'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import MappingUpdateModalUI from './MappingUpdateModalUI.js'

class MappingUpdateModalSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      successMsg: null,
      errorList: null,
      mappingId: null,
      // sourceValue
      sourceValue: '',
      sourceValueError: null,
      // mappedValue
      mappedValue: '',
      //
      ignoreSpaces: '',
      // form events
      submitted: false,
    }
  }

  render() {
    let booleanList = [
      { key: 'true', value: 'Yes' },
      { key: 'false', value: 'No' },
    ]
    return (
      <MappingUpdateModalUI
        context={this.props.context}
        errorList={this.state.errorList}
        successMsg={this.state.successMsg}
        setErrorList={this.setErrorList}
        // sourceValue
        sourceValue={this.state.sourceValue}
        onSourceValueChange={(event) => { this.setState({ sourceValue: event.target.value }) }}
        sourceValueError={this.state.sourceValueError}
        setSourceValueError={(error) => { this.setState({ sourceValueError: error }) }}
        // mappedValue
        mappingGroup={this.props.mappingGroup}
        mappedValue={this.state.mappedValue}
        mappedValueList={this.props.mappedValueList}
        onMappedValueChange={(event) => { this.setState({ mappedValue: event.target.value }) }}
        //
        ignoreSpaces={this.state.ignoreSpaces}
        onIgnoreSpacesChange={(event) => { this.setState({ ignoreSpaces: event.target.value }) }}
        booleanList={booleanList}
        // modes
        updateMode={this.props.updateMode}
        submitted={this.state.submitted}
        // event handlers
        onSubmit={this.onSubmit}
        onCancelClick={this.props.onCancelClick}
      />
    )
  }

  componentDidMount() {
    Modal.setAppElement('body')
  }

  componentDidUpdate(prevProps) {
    if (!this.props.selectedMapping)
      return
    if (!prevProps.selectedMapping || prevProps.selectedMapping.mappingId !== this.props.selectedMapping.mappingId) {
      this.setState({
        mappingId: this.props.selectedMapping.mappingId,
        sourceValue: this.props.selectedMapping.sourceValue,
        mappedValue: this.props.selectedMapping.mappedValue,
        ignoreSpaces: this.props.selectedMapping.ignoreSpaces,
        errorList: null,
        submitted: false
      })
    }
  }

  onSubmit = () => {
    let submitted = this.state.submitted
    if (submitted)
      return

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true
    })

    let context = this.props.context
    RestApiUtils.put(this.props.context,
      `/api/su/mappings/bank_analyzer_keywords/mappingId/${this.state.mappingId}`,
      this.onSubmitCallback, {
      sourceValue: this.state.sourceValue,
      mappedValue: this.state.mappedValue,
      ignoreSpaces: this.state.ignoreSpaces
    }
    )
  }

  onSubmitCallback = (response) => {
    let errorList = [];

    if (response.errorList && Array.isArray(response.errorList)) {
      response.errorList.forEach(error => {
        errorList.push(error.message);

        switch (error.fieldName) {
          case 'sourceValue':
            this.setState({ sourceValueError: error.message });
            break;
          default:
            break;
        }
      });
    } else {
      errorList.push(
        response.error ||
        response.message ||
        'Something went wrong. Please try again.'
      );
    }

    this.setState({
      successMsg: response.success,
      errorList,
      submitted: false
    });

    if (errorList.length === 0) {
      setTimeout(() => {
        this.setState({
          successMsg: null
        });
        this.props.onCancelClick();
        this.props.onRefreshClick();
      }, 2000);
    }
  }

  setErrorList = (errorList) => {
    this.setState({ errorList: errorList })
    if (errorList && errorList.length > 0)
      window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
  }
}

export default withRouter(MappingUpdateModalSF)
